import { useTranslation } from 'next-i18next'

import type { CollectionHit } from '@/utils/algolia/autocompleteHitTypes'

import searchBoxStyles from '../../../SearchBox.module.css'
import { AutocompleteItem, HighlightedText } from '../../components'

export const CollectionOption = ({
	item,
	activeItemId,
}: {
	item: CollectionHit
	activeItemId: number
}): JSX.Element => {
	const { t } = useTranslation(['search'])
	const {
		imageUrl,
		value,
		availableTitles,
		url,
		__autocomplete_id: index,
	} = item

	return (
		<a
			aria-selected={activeItemId === index}
			className={searchBoxStyles.option}
			data-value={value}
			id={`${value}-listbox-option`}
			role="option"
			href={url}
			target="_blank"
			rel="noreferrer"
			data-testid="collection-suggestion"
		>
			<AutocompleteItem
				image={{
					src: imageUrl || '',
					alt: value,
				}}
				title={<HighlightedText AlgoliaHit={item} fields={availableTitles} />}
				subtitle={t('collection')}
				pageUrl={url}
			/>
		</a>
	)
}
